import React, { FunctionComponent } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import useFluidImage from '../FluidImageProvider/useFluidImage';
import FluidImage from './Image/FluidImage';

export interface ImageProps {
  id: string;
  caption?: string;
  alt?: string;
  hotspot?: {
    x?: number;
    y?: number;
  };
}

const useStyles = () => {
  const { spacing, boxShadow } = useTheme();
  return {
    root: {
      display: 'inline-flex',
      width: '100%',
    },
    image: {
      borderRadius: spacing(2),
      boxShadow: boxShadow('shadow', 2),
      overflow: 'hidden',
    },
    caption: {
      margin: spacing(2, 0, 0),
    },
  };
};

const Image: FunctionComponent<ImageProps> = (props) => {
  const { alt = '', caption, id, hotspot } = props;
  const classes = useStyles();

  const image = useFluidImage(id);

  if (!image) {
    return null;
  }
  return (
    <Flex css={classes.root} flexDirection="column" margin={[4, 0]}>
      <FluidImage css={classes.image} image={image} alt={alt} id={id} hotspot={hotspot} />
      {caption ? (
        <Text css={classes.caption} variant="message4">
          {caption}
        </Text>
      ) : null}
    </Flex>
  );
};

export default Image;
